import { RedoFulfillmentToteSchema } from "@redotech/redo-model/fulfillments/fulfillment-tote";
import * as z from "zod";

export const getNewToteBarcodes = {
  name: "getNewToteBarcodes" as const,
  input: z.object({ toteIds: z.array(z.string()) }),
  output: z.object({ totes: z.array(RedoFulfillmentToteSchema) }),
};

export type GetNewToteBarcodesInput = z.infer<typeof getNewToteBarcodes.input>;
